import { createContext, useContext } from "react";

export const PlanContext = createContext({
  plan: "free",
  limits: null,
  usage: null,
  subscription: null,
  refresh: () => {},
  openUpgrade: () => {},
  isAllowedModel: () => true,
  canPersonalize: true,
});

export const usePlan = () => useContext(PlanContext);
